angular
  .module('iqxCore')
  .controller('TimesheetSigningCtrl', function ($scope, $routeParams, $q, $timeout, $filter, FormSvc, $location, sendMessageDialogSvc, SweetAlert, ApiSvc, ApplicationSvc, BehaviourSvc, $http, $window, TerminologySvc, $cookies) {
    $scope.authenticated = $routeParams.authenticated === '1'
    FormSvc.setOptions($scope, {
      notLoggedIn: $routeParams.authenticated === '1' ? true : false,
      autoEdit: true
    }) // stop the "please cancel or save your edits, message!"

    $scope.URLRequestCode = $routeParams.URLRequestCode
    $scope.selects = {}
    $scope.selects.payBandType = {}
    $scope.paybandChanged = false
    $scope.classes = {
      label: 'col-sm-4',
      data: 'col-sm-6'
    } // Deliberatly not adding to 12 so as to indent from right margin
    $scope.showSignForm = false
    $scope.signDetails = {}
    $scope.signaturePad = {}
    $scope.finished = false
    $scope.ready = false
    $scope.$parent.forceHideSidebarMenu = true
    $scope.emailList = []
    $scope.divisionTimesheetSigningRights = {}
    $scope.terminology = {}
    $scope.loading = false
    $scope.failedSignData = {}

    var geo = {}

    $scope.$on('$routeChangeStart', function ($event, next, current) {
      $scope.$parent.forceHideSidebarMenu = undefined
    })

    $scope.goBack = function () {
      $scope.$parent.forceHideSidebarMenu = undefined
      return $location.url('/provtimesheets/fill')
    }

    $scope.getSigningDetails = function () {
      return $scope
        .fetch({
          fetchAPI: 'callresult_/NetProvTimesheetSendLinkForApproval?pURLRequestCode=' + $scope.URLRequestCode,
          fetchTarget: 'signingDetails',
          notLoggedIn: $routeParams.authenticated === '1' ? false : true,
          autoEdit: true,
          multiRow: false
        })
        .then(function () {
          if ($scope.signingDetails.tempprovtimesheetid === '' || !$scope.signingDetails.tempprovtimesheetid) {
            FormSvc.alert('Malformed URL', 'Please check the URL and try again.', 'error')
            console.error('Malformed URL')
            throw new Error('Malformed URL')
          }
        })
        .then(function () {
          $scope.ProvTSID = $scope.signingDetails.tempprovtimesheetid
        })
        .then(function () {
          // if not authenticated, get the behaviour for the ts division
          if ($routeParams.authenticated !== '1') {
            return BehaviourSvc.get($scope.signingDetails.divisionid)
          }
        })
        .then(function () {
          // if not authenticated, set the behaviour for the ts division in the application service params
          if ($routeParams.authenticated !== '1') {
            ApplicationSvc.params.behaviour = angular.fromJson($cookies.getObject('IQXBehaviour'))
          }
        })
        .then(function () {
          $scope.divisionTimesheetSigningRights = BehaviourSvc.timesheetSigningSettings()
          // #region Setup Terminology
          TerminologySvc.getTerminology(
            [
              'thanksMessage',
              'thanksMessageClose',
              'thanksMessageDone',
              'thanksMessageDoneBtn',
              'orderedBy',
              'shifts',
              'date',
              'shift',
              'times',
              'break',
              'hours',
              'reference',
              'from',
              'rates',
              'paytype',
              'unit',
              'units',
              'rate',
              'grade',
              'total',
              'expenses',
              'expense',
              'noExpensesAdded',
              'signedBy',
              'position',
              'timestamp',
              'geoLocation',
              'geoPermissionDenied',
              'completeAndSignNow',
              'btnQuery',
              'btnPrint',
              'signInfo',
              'addSignature',
              'yourSignature',
              'clearSignature',
              'name',
              'yourPosition',
              'sendCopy',
              'yourEmail',
              'awaitsAuthorisationHelp',
              'queryPendingHelp',
              'needsSignatureHelp',
              'provisionalHelp',
              'signerEmail',
              'candidateConfirmTimesheetSignMessage',
              'deviceRotationMessage',
              'authorisedEmailSignersOnly',
              'signWarningMoreThan1Shift'
            ],
            $routeParams.authenticated !== '1' ? $scope.signingDetails.divisionid : null
          )
            .then(function (value) {
              $scope.terminology = value
            })
            .catch(function (error) {
              console.error(error)
            })
          // #endregion
        })
        .then(function () {
          FormSvc.setOptions($scope, {
            fetchAPI: 'callresult_/NetProvTimesheet?pTempProvTimesheetID=' + $scope.ProvTSID + '&pURLRequestCode=' + $scope.URLRequestCode,
            saveAPI: 'call_/NetProvTimesheetSet',
            primaryKey: 'tempprovtimesheetid',
            savePrefix: 'p',
            dateFields: ['weekenddate'],
            booleanFields: ['theirrefrequired', 'completed', 'hasScannedImage', 'allowedToAuthorise', 'allowedToApprove', 'ShiftsOnContractTimesheet'],
            doNotPreventNav: true,
            notLoggedIn: $routeParams.authenticated === '1' ? false : true,
            autoEdit: true,
            questionnaire: {
              tagTarget: 'tags',
              id: $scope.ProvTSID,
              tagLocation: $scope.divisionTimesheetSigningRights.clientDepartmentalQuestions ? 'T' + $scope.signingDetails.departmentid : 'T',
              displayGroup: $scope.divisionTimesheetSigningRights.clientDepartmentalQuestions ? false : 'CLITSCOMP',
              postVar: 'qanswers',
              questionGroup: $scope.divisionTimesheetSigningRights.clientDepartmentalQuestions ? 20 : false
            }
          })
        })
    }

    $scope.fetchTimesheet = function () {
      // Fetch the timesheet header
      return $scope
        .fetch() // The primary fetch using the scope options above
        .then(function () {
          if ($scope.theRecord.tempprovtimesheetid) {
            $scope.ready = true
            $scope.state.loaded = true
          } else {
            $scope.ready = true
            $scope.state.loaded = false
            return $q.reject()
          }
        })
    }

    $scope.fetchQueryType = function () {
      return $scope.fetch({
        fetchAPI: 'callresult_/NetTimesheetQueryType',
        fetchTarget: 'queryType',
        notLoggedIn: $routeParams.authenticated === '1' ? false : true
      })
    }

    $scope.sendTimesheetQueryForm = function () {
      return $scope
        .fetch({
          fetchAPI: 'callresult_/NetTimesheetQueryReasons?pUserType=Client&pDivisionID=' + $scope.signingDetails.divisionid,
          fetchTarget: 'queryReasons',
          multiRow: true,
          notLoggedIn: $routeParams.authenticated === '1' ? false : true
        })
        .then(function () {
          return FormSvc.modalForm($scope, 'timesheetQueryReasonForm', {}, 'md', {
            label: 'col-sm-3',
            data: 'col-sm-7'
          }).then(function (reasonModel) {
            return $scope
              .exec('call_/NetTimesheetQueryInsert', {
                pReasonCode: reasonModel.pReasonCode,
                pTempprovTimesheetID: $scope.ProvTSID,
                pNotes: reasonModel.pNotes,
                pClientContactName: reasonModel.pClientContactName,
                pClientContactPhone: reasonModel.pClientContactPhone,
                pClientContactEmail: reasonModel.pClientContactEmail
              })
              .then(function (response) {
                SweetAlert.swal({
                  title: 'Query Sent',
                  text: '',
                  type: 'success'
                })
              })
          })
        })
    }

    $scope.load = function () {
      // Load whole timesheet
      $scope.theRecord = {}
      $scope.state = {
        loaded: false, // The provisional timesheet was successfully loaded
        calculated: false, // The calculated timesheet lines/rates are available
        completed: false, // Timesheet has been flagged as completed
        showingDetails: true, // Display the shifts/time details
        shiftTimesheet: false, // This is a shift timesheet
        shiftBreaks: false, // There is a non-zero break in one or more of the shifts
        shiftRefs: false, // There is a shift reference in one or more of the shifts
        rateDates: false, // Some of the rates have dates
        timeTimesheet: false, // This is a pseudo-shift timesheet
        contractTimesheet: false, // This timesheet has neither shifts nor pseudo-shifts
        useShiftTypes: false, // Allow specification of shift type when adding/editing shift
        hourTotalsMismatch: false, // Used to display a warning when the shift hours don't match the rate hours
        allowedToAuthorise: false,
        allowedToApprove: false,
        canEditTheirRef: false,
        canEditDescription: false,
        canEditBreak: false,
        minuteStep: false,
        showRates: false,
        showPaymentType: false,
        showExpenses: false,
        canAddShift: false,
        canCopyShift: false,
        canDeleteShift: false,
        canCopyPayLines: false,
        allowMismatchCalculated: false,
        imageRequired: false,
        imageAllowed: true,
        canSendAndApprove: false,
        canSendLinkForApprove: false,
        allowUntickCalc: false,
        signEachBreak: false
      }
      return $scope
        .fetchQueryType()
        .then($scope.fetchTimesheet)
        .then(function () {
          if (!$scope.theRecord.allowedToAuthorise) {
            $scope.state.allowedToAuthorise = false
          }
          if (!$scope.theRecord.allowedToApprove) {
            $scope.state.allowedToApprove = false
          }
          if ($scope.theRecord.timesheettype == 'S') {
            $scope.state.shiftTimesheet = true
            $scope.state.canAddShift = false
            $scope.state.canCopyShift = false
            return $scope.fetchTimesheetShifts()
          } else if ($scope.theRecord.timesheettype == 'T') {
            $scope.state.timeTimesheet = true
            return $scope.fetchTimesheetTimes()
          }
        })
        .then(function () {
          if (!($scope.state.shiftTimesheet || $scope.state.timeTimesheet)) {
            $scope.state.contractTimesheet = true
          }
          if ($scope.theRecord.completed || $scope.state.contractTimesheet) {
            $scope.state.calculated = true
            $scope.state.completed = $scope.theRecord.completed
            $scope.state.showingDetails = true //!$scope.theRecord.completed
            return $scope.fetchTimesheetRates()
          }
        })
        .then(function () {
          // Get expense images
          return $scope
            .fetch({
              fetchAPI: 'callresult_/NetProvTimesheetExpenseImages?pTempProvTimesheetID=' + $scope.ProvTSID,
              fetchTarget: 'expenseImages',
              multiRow: true,
              notLoggedIn: true
            })
            .then(function () {
              $scope.TimeSheetExpenses.forEach(function (expense) {
                expense.images = []
                $scope.expenseImages.filter(function (img) {
                  if (img.timesheetlineid === expense.TempProvTimesheetLineID) {
                    expense.images.push(img)
                    return img
                  }
                })
              })
            })
        })
        .then(function () {
          if ($scope.theRecord.ShiftsOnContractTimesheet) {
            $scope.shiftTypes = {}
            // Don't use shift type combo
          } else {
            return $scope.fetchShiftTypes()
          }
        })
        .then(function () {
          if (!$scope.state.completed) {
            return $timeout($scope.setEditing, 0, true, true) // Wrap in timeout to ensure DOM is built and ready first
          }
        })
        .then(function () {
          if ($scope.timesheetShifts.length < 1 && $scope.timesheetRates.length < 1) {
            FormSvc.alert('No shifts to sign', 'You need to include at least one shift.', 'error')
            return $location.url('/provtimesheet?id=' + $scope.ProvTSID)
          }
        })
    }

    $scope.viewExpenseImage = function (img) {
      return $http
        .get('/api/document/doxi', {
          params: {
            class: 'O',
            ext: 'pdf',
            id: img.PDFImageBlobID
          }
        })
        .then(function (res) {
          $window.open('/api/document/download?doxi=' + res.data, '_blank')
        })
    }

    $scope.viewExpenseImages = function (expense) {
      var data = {
        expense: expense,
        choices: [
          {
            desc: 'Close',
            type: 'danger',
            code: ''
          }
        ]
      }
      return FormSvc.modalInfo($scope, 'manageExpenseImages', data, 'lg')
    }

    $scope.fetchTimesheetShifts = function () {
      return $scope
        .fetch({
          fetchAPI: 'callresult_/netprovtimesheetshifts?pTempProvTimesheetID=' + $scope.ProvTSID,
          fetchTarget: 'timesheetShifts',
          multiRow: true,
          notLoggedIn: $routeParams.authenticated === '1' ? false : true,
          dateFields: ['weekenddate', 'shiftdate'],
          timeFields: ['timefrom', 'timeto'],
          booleanFields: ['tick'],
          numberFields: ['breakminutes', 'shiftduration']
        })
        .then($scope.checkForShiftContent) // Sets state.shiftBreaks and state.shiftRefs as appropriate
        .then(function () {
          return $scope.fetch({
            fetchAPI: 'callresult_/NetProvTimesheetShiftCheckDates?pTempProvTimesheetID=' + $scope.ProvTSID,
            fetchTarget: 'shiftDates',
            multiRow: false,
            notLoggedIn: $routeParams.authenticated === '1' ? false : true,
            dateFields: ['startdate', 'enddate']
          })
        })
        .then(function () {
          $scope.dateOptions = {
            initDate: $scope.shiftDates.startdate,
            minDate: $scope.shiftDates.startdate,
            maxDate: $scope.shiftDates.enddate
          }
        })
    }

    $scope.fetchTimesheetTimes = function () {
      return $scope.fetch({
        fetchAPI: 'callresult_/netprovtimesheettimes?pTempProvTimesheetID=' + $scope.ProvTSID,
        fetchTarget: 'timesheetTimes',
        multiRow: true,
        notLoggedIn: $routeParams.authenticated === '1' ? false : true,
        dateFields: ['weekstartdate', 'shiftdate'],
        timeFields: ['timefrom'],
        booleanFields: ['dayticked'],
        numberFields: ['hours']
      })
    }

    $scope.fetchShiftTypes = function () {
      return $scope
        .fetch({
          fetchAPI: 'callresult_/netshifttypes',
          fetchTarget: 'shiftTypes',
          multiRow: true,
          notLoggedIn: $routeParams.authenticated === '1' ? false : true
        })
        .then(function () {
          if ($scope.shiftTypes.length) {
            $scope.state.useShiftTypes = true
          }
        })
    }

    $scope.fetchTimesheetRates = function () {
      return $scope
        .fetch({
          fetchAPI: 'callresult_/netprovtimesheetrates?pTempProvTimesheetID=' + $scope.ProvTSID + '&pURLRequestCode=' + $scope.URLRequestCode,
          fetchTarget: 'timesheetRates',
          multiRow: true,
          notLoggedIn: $routeParams.authenticated === '1' ? false : true,
          booleanFields: ['IsExpenses', 'CanEdit', 'CanEditUnits', 'AddExpenseImageToInvoice', 'ExpenseImageRequired', 'ExpenseImageAllowed'],
          numberFields: ['Units', 'Rate']
        })
        .then(function () {
          return ApiSvc.fetch($scope, {
            fetchAPI: 'callresult_/NetProvTimesheetExpenseRatesSelect?pTempProvTimesheetID=' + $scope.ProvTSID, // fetch the pay bands
            fetchTarget: 'paybandTypes',
            multiRow: true,
            notLoggedIn: true
          })
        })
        .then(function () {
          $scope.TimeSheetExpenses = $filter('filter')($scope.timesheetRates, function (o) {
            if (o.IsExpenses == true && o.Total > 0 && o.AddExpenseImageToInvoice) {
              return o
            }
          })
          $scope.hasTimesheetExpensesAvailable = $scope.paybandTypes.length > 0
          $scope.checkHourTotals()
        })
        .then(function () {
          $scope.checkForRateContent()
        })
    }

    $scope.showDetails = function () {
      // Switch on the times/shifts visibility
      $scope.state.showingDetails = true
    }

    $scope.shiftLength = function (sh) {
      // Shift duration in hours
      var start = moment().hours(sh.timefrom.getHours()).minutes(sh.timefrom.getMinutes())
      var end = moment().hours(sh.timeto.getHours()).minutes(sh.timeto.getMinutes())
      var len = end.diff(start, 'hours', true)
      if (len < 0) {
        len = 24.0 + len
      } // Overnight
      if (sh.breakminutes) {
        len = len - sh.breakminutes / 60
      }
      len = Math.round(len * 100) / 100 // round to 2 dp
      return len
    }

    $scope.checkHourTotals = function () {
      $scope.state.hourTotalsMismatch = false
      if (!$scope.state.calculated) {
        return
      }
      if (!($scope.state.shiftTimesheet || $scope.state.timeTimesheet)) {
        return
      }
      $scope.timesheetRatesHourTotal = FormSvc.arrayTotal($scope.timesheetRates, 'Units', function (rt) {
        return !rt.IsExpenses && rt.UnitDescription.match(/^hour/i)
      })
      if ($scope.state.shiftTimesheet) {
        $scope.timesheetShiftsHourTotal = FormSvc.arrayTotal($scope.timesheetShifts, $scope.shiftLength, function (sh) {
          return sh.tick
        })
      } else {
        $scope.timesheetShiftsHourTotal = FormSvc.arrayTotal($scope.timesheetTimes, 'hours')
      }
    }

    $scope.checkForRateContent = function () {
      var haveDates = false
      angular.forEach($scope.timesheetRates, function (rt) {
        if (rt.ShiftDate && !rt.IsExpenses) {
          haveDates = true
        }
      })
      $scope.state.rateDates = haveDates
    }

    $scope.getTotal = function () {
      var res = 0
      angular.forEach($scope.timesheetRates, function (value, key) {
        if(value.IsExpenses === false) {
          res += Number(value.Total)
        }
      })
      return res
    }
  
    $scope.getTotalHours = function () {
      var res = 0
      angular.forEach($scope.timesheetRates, function (value, key) {
        if(value.IsExpenses === false) {
          res += Number(value.Units)
        }
      })
      return res
    }

    $scope.checkForShiftContent = function () {
      var haveBreaks = false,
        haveRefs = false
      angular.forEach($scope.timesheetShifts, function (sh) {
        if (sh.breakminutes) {
          haveBreaks = true
        }
        if (sh.referencecode) {
          haveRefs = true
        }
      })
      $scope.state.shiftBreaks = haveBreaks
      $scope.state.shiftRefs = haveRefs
    }

    function toDataURL(url, callback) {
      var xhr = new XMLHttpRequest()
      xhr.onload = function () {
        var reader = new FileReader()
        reader.onloadend = function () {
          callback(reader.result)
        }
        reader.readAsDataURL(xhr.response)
      }
      xhr.open('GET', url)
      xhr.responseType = 'blob'
      xhr.send()
    }

    $scope.getLocationFromGEO = function (geo) {
      return fetch('https://nominatim.openstreetmap.org/reverse?format=json&lat=' + geo.latitude + '&lon=' + geo.longitude)
        .then((response) => response.json())
        .then(function (response) {
          var resp = response.address
          if (resp.town) {
            $scope.geoText = 'Signed at ' + resp.town
          } else if (resp.city) {
            $scope.geoText = 'Signed at ' + resp.city
          } else if (resp.county) {
            $scope.geoText = 'Signed at ' + resp.county
          } else {
            $scope.geoText = 'GEO location captured'
          }
        })
    }

    $scope.getIPAddress = function (geo) {
      return fetch('https://ipinfo.io/json')
        .then((response) => response.json())
        .then(function (response) {
          $scope.ipAddress = response.ip
        })
    }

    $scope.reportBadEmailUse = function (badEmail, usedOwnEmail) {
      return ApiSvc.exec(
        $scope,
        'call_/NetCandidateTSBadEmail',
        {
          pAttemptedEmail: badEmail,
          pPersonID: ApplicationSvc.currentUser.personID,
          usedOwnEmail: usedOwnEmail
        },
        $routeParams.authenticated === '1' ? false : true
      )
    }

    $scope.signTimesheetQuestion = function () {
      if (
        ($scope.theRecord.timesheettype === 'S' && $scope.timesheetShifts.length > 1 && $scope.divisionTimesheetSigningRights.showWarningIfMoreThan1Shift === true) ||
        ($scope.theRecord.timesheettype === 'T' && $scope.timesheetTimes.length > 1 && $scope.divisionTimesheetSigningRights.showWarningIfMoreThan1Shift === true)
      ) {
        SweetAlert.swal({
          title: '',
          confirmButtonText: 'Proceed',
          confirmButtonColor: '#337ab7',
          type: 'warning',
          text: $scope.terminology.signWarningMoreThan1Shift,
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false
        }).then(function (result) {
          if (result.value) {
            return $scope.signTimesheet()
          }
        })
      } else {
        return $scope.signTimesheet()
      }
    }

    $scope.signTimesheet = function () {
      var badEmailList = []
      $scope.theRecord.URLRequestCode = $scope.URLRequestCode
      return FormSvc.update($scope, true)
        .then(function () {
          return ApiSvc.exec($scope, 'candidate-json/bad-email-domains', {}, $routeParams.authenticated === '1' ? false : true).then(function (badEmails) {
            badEmailList = badEmails.IQXResult.Row.emails
          })
        })
        .then(function () {
          FormSvc.modalForm(
            $scope,
            'signForm',
            $scope.failedSignData,
            'xl',
            {
              label: 'col-sm-2',
              data: 'col-sm-10'
            },
            {},
            $scope.triggerSignature
          ).then(function (timesheetData) {
            if ($scope.signaturePad.isEmpty()) {
              $scope.failedSignData = timesheetData
              FormSvc.alert('Error', 'Signature is empty, please re-sign the timesheet.', 'error')
              return $scope.signTimesheet()
            }

            if ($scope.emailList.length > 0) {
              // We have some emails in the list to send to
              if (timesheetData.email || timesheetData.email !== '') {
                // if there is a valid email in the textbox, add it to the list
                $scope.emailList.push(timesheetData.email)
              }
              timesheetData.email = $scope.emailList.join(';') // email list string
            } else {
              if ($routeParams.authenticated === '1') {
                // Signing on the device.
                if (timesheetData.email === null || !timesheetData.email || timesheetData.email === '') {
                  // if the email field is empty
                  FormSvc.alert('Error', 'Please enter an email address.', 'error')
                  return $scope.signTimesheet()
                } else {
                  $scope.emailList.push(timesheetData.email)
                }
              }
            }

            var emailError = false

            $scope.emailList.forEach(function (email) {
              // BAD EMAILS
              if (email.includes(ApplicationSvc.currentUser.registrationDetails.EmailAddress)) {
                $scope.emailList = []
                FormSvc.alert('Error', $scope.terminology.authorisedEmailSignersOnly, 'error')
                $scope.reportBadEmailUse(email, 1)
                emailError = true
                return $timeout($scope.goBack, 500)
              }

              var emailDomain = email.substring(email.lastIndexOf('@') + 1)
              if (badEmailList.includes(emailDomain)) {
                $scope.emailList = []
                FormSvc.alert('Error', $scope.terminology.authorisedEmailSignersOnly, 'error')
                $scope.reportBadEmailUse(email, 0)
                emailError = true
                return $timeout($scope.goBack, 500)
              }
            })

            if (emailError) {
              return false
            }

            $scope.loading = true

            $scope.signDetails = {
              name: timesheetData.name,
              position: timesheetData.position,
              sendcopy: $scope.divisionTimesheetSigningRights.alwaysSendTimesheetSummary ? 1 : timesheetData.sendcopy,
              timestamp: moment().format('DD/MM/YYYY HH:mm'),
              geolocation: geo,
              signature: $scope.signaturePad.isEmpty() ? false : $scope.signaturePad.toDataURL('image/png'),
              email: timesheetData.email ? timesheetData.email : $scope.signingDetails.emailAddress
            }

            $timeout(function () {
              window.scrollTo(0, 0)
              $scope.failedSignData = {}
              return $scope.saveSignature()
            }, 0)
          })

          $scope.state.completed = true
        })
    }

    $scope.saveSignature = function () {
      var data = {
        pdfTemplate: ApplicationSvc.params.behaviour.TSSPDFTEMPLATE,
        signDetails: {
          pWhoSigned: $scope.signDetails.name,
          pSignerPosition: $scope.signDetails.position,
          pLatitude: geo.latitude,
          pLongitude: geo.longitude,
          pSignature: $scope.signDetails.signature,
          pLocationName: $scope.geoText,
          ptimestamp: $scope.signDetails.timestamp,
          pEmail: $scope.signDetails.email
        },
        pSignatureType: 'CLIENT',
        pTempProvTimesheetID: $scope.ProvTSID,
        pLogo: ApplicationSvc.params.behaviour.TSSLOGOFILE,
        pURLRequestCode: $scope.URLRequestCode,
        pEmailRequested: $scope.signDetails.sendcopy,
        pEmail: $scope.signDetails.email,
        pNotes: `ipaddress=${$scope.ipAddress};useragent=${navigator.userAgent}`,
        theRecord: $scope.theRecord,
        tags: $scope.tags,
        shiftDates: $scope.shiftDates,
        timesheetShifts: $scope.timesheetShifts,
        timesheetTimes: $scope.timesheetTimes,
        timesheetRates: $scope.timesheetRates.filter(function (rate) {
          return rate.IsExpenses === false
        }),
        TimeSheetExpenses: $scope.TimeSheetExpenses,
        terminology: $scope.terminology,
        state: $scope.state,
        divisionTimesheetSigningRights: $scope.divisionTimesheetSigningRights
      }
      return $scope
        .exec('pdfTemplate/timesheet', data)
        .then(function (res) {
          $scope.finished = true
          $scope.loading = false
          if (res.IQXResult.attrs.success) {
            return FormSvc.alert('Timesheet Signed', 'Thank you for your time', 'success')
          } else {
            console.error(res)
            throw new Error(res)
          }
        })
        .catch(function (res) {
          return FormSvc.alert('Error', 'Something went wrong, please try again later.', 'error')
        })
    }

    $scope.triggerSignature = function () {
      $timeout(function () {
        var canvas = document.querySelector('canvas')
        $scope.signaturePad = new SignaturePad(canvas, {
          // backgroundColor: "rgb(255,255,255)"
        })

        if (navigator.geolocation && $scope.divisionTimesheetSigningRights.captureGEOLocation !== false) {
          navigator.geolocation.getCurrentPosition(function (position) {
            geo = {
              longitude: position.coords.longitude,
              latitude: position.coords.latitude
            }
            $scope.getLocationFromGEO(geo)
            $scope.getIPAddress()
          })
        }
        $scope.showSignForm = true
      }, 1)
    }

    $scope.resetCanvas = function () {
      $scope.signaturePad.clear()
    }

    $scope.sendMessage = function () {
      sendMessageDialogSvc.createMessageFromDialog($scope, 'TIMESHEET', 'Query Timesheet ' + $scope.theRecord.serialnumber, {
        pprovtimesheetid: $scope.ProvTSID
      })
    }

    $scope.addEmailAddress = function (scope) {
      if (scope.theRecord.email && scope.theRecord.email !== '') {
        $scope.emailList.push(scope.theRecord.email)
        scope.theRecord.email = ''
      }
    }

    $scope.removeEmailFromList = function (i) {
      $scope.emailList.splice(i, 1)
    }

    $scope
      .getSigningDetails()
      .then($scope.load)
      .then(function () {
        if ($scope.divisionTimesheetSigningRights && $scope.divisionTimesheetSigningRights.signEachBreak) {
          return $scope
            .fetch({
              fetchAPI: 'callresult_/NetGetCompanyQuestionValue?pCompanyID=' + $scope.theRecord.companyid + '&pQuestionID=' + $scope.divisionTimesheetSigningRights.signEachBreak,
              fetchTarget: 'signEachBreak',
              notLoggedIn: $routeParams.authenticated === '1' ? false : true
            })
            .then(function () {
              if ($scope.signEachBreak.textvalue.toUpperCase() === 'Y') {
                $scope.state.signEachBreak = true
              }
            })
        }
      })
  })
